import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import { BiChevronsRight } from "react-icons/bi";
import banner from "../../../assets/images/ASSISTED-LIVING-FACILITIES/CCRC-750x400.jpg";
import ALFimg from "../../../assets/images/ASSISTED-LIVING-FACILITIES/OIP__1_-removebg-preview.png";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";

// import Aos from 'aos';
// import 'aos/dist/aos.css';
// import { useEffect } from "react";

const ALF = () => {
  // useEffect(() => {
  //   Aos.init({duration: 2000});
  // }, []);

  return (
    <ALFConatiner>
      <TopServiceBanner title=" ALF's & LTC's " banner={banner} />
      <ALFInner>
        <ALFTitle>ALWAYS READY IN YOUR SERVICE</ALFTitle>
        <ALFSubTitle>
          Senior Care Community Pharmacy Helped (ALF's) is unique in relation to
          the typical drug stores. Our complete drug store administrations are
          planned explicitly for the extraordinary requirements of long haul
          care and helped living offices. We offer extra types of assistance for
          patients in helped residing homes that most different drug stores
          don't offer. With our broad mastery and long stretches of involvement,
          we center around customized drug store arrangements, trend setting
          innovation assets, as well as an excellent help and administrations.
        </ALFSubTitle>
        <ALFMiddle>
          <ALFMiddleSubTitle>
            Our capable drug specialists and experts are promptly accessible to
            help every patient's necessities, and work determinedly to address
            or tackle their inquiries.
          </ALFMiddleSubTitle>
          <ALFMiddleInner>
            <ALFMiddleInnerLeft>
              <ALFMiddleTextLeft>WHAT DO WE OFFER?</ALFMiddleTextLeft>
              <AlfUl>
                <AlfLi>
                  {" "}
                  <BiChevronsRight />
                  24x7 services available
                </AlfLi>
                <AlfLi>
                  {" "}
                  <BiChevronsRight />
                  Plentiful packaging options
                </AlfLi>
                <AlfLi>
                  {" "}
                  <BiChevronsRight />
                  Quality care and support
                </AlfLi>
                <AlfLi>
                  {" "}
                  <BiChevronsRight />
                  Excellent customer service
                </AlfLi>
                <AlfLi>
                  {" "}
                  <BiChevronsRight />
                  Affordable pricing
                </AlfLi>
                <AlfLi>
                  {" "}
                  <BiChevronsRight />
                  Pharmacist consultation
                </AlfLi>
                <AlfLi>
                  {" "}
                  <BiChevronsRight />
                  Immediate emergency service
                </AlfLi>
                <AlfLi>
                  <BiChevronsRight />
                  Effective communication between pharmacy, physician and
                  community
                </AlfLi>
              </AlfUl>
            </ALFMiddleInnerLeft>
            <ALFMiddleInnerRight>
              <ALFImg src={ALFimg} alt="ALF" />
            </ALFMiddleInnerRight>
          </ALFMiddleInner>
        </ALFMiddle>

        <ALFSubBottomTitle>
          We give adaptable and contemporary arrangements uniquely designed to
          upgrade nature of care, oversee medicine regimens and ad lib working
          effectiveness. We likewise guarantee to meet the rising drug store
          administration prerequisites for the Helped Living Consideration
          people group it serves.
        </ALFSubBottomTitle>
      </ALFInner>
      <BottomServiceBanner />
      <BottomBanner />
    </ALFConatiner>
  );
};

export default ALF;

const ALFConatiner = styled.div``;
const ALFInner = styled.div``;

const ALFSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;
const ALFMiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 10rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const ALFSubBottomTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const ALFMiddle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding-bottom: 10rem;
  padding-top: 1rem;
`;
const ALFMiddleInner = styled.div`
  display: flex;
  justify-content: space-around;

  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }
`;

const ALFMiddleInnerLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const ALFMiddleInnerRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ALFMiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 2rem;
  }
`;

const AlfUl = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const AlfLi = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const ALFImg = styled.img`
  width: 100%;
  height: 100%;

  @media (max-width: 1180px) {
    width: 45%;
    height: 45%;
    margin-top: 1rem;
  }
`;
const ALFTitle = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;
